define('core/worker',["exports", "core/utils", "deps/text!../../worker/respec-worker.js"], function (exports, _utils, _respecWorker) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.worker = exports.name = undefined;

  var _respecWorker2 = _interopRequireDefault(_respecWorker);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  /**
   * Module core/worker
   *
   * Exports a Web Worker for ReSpec, allowing for
   * multi-threaded processing of things.
   */
  const name = exports.name = "core/worker";

  // Opportunistically preload syntax highlighter, which is used by the worker

  // Opportunistically preload syntax highlighter
  const hint = {
    hint: "preload",
    href: "https://www.w3.org/Tools/respec/respec-highlight.js",
    as: "script"
  };
  const link = (0, _utils.createResourceHint)(hint);
  document.head.appendChild(link);

  const workerURL = URL.createObjectURL(new Blob([_respecWorker2.default], { type: "application/javascript" }));
  const worker = exports.worker = new Worker(workerURL);
});
//# sourceMappingURL=worker.js.map;
